import { Controller } from '@hotwired/stimulus';

// Section scrollspy for content pages. Default uses Bootstrap 5.3 ScrollSpy;
// `stickyOffset` (the sticky /reports section menu) switches to an
// IntersectionObserver, since Bootstrap's ScrollSpy mis-tracks once a sticky
// bar covers the top of the active section.
export default class extends Controller {
  static values = { stickyOffset: Boolean };

  #spy;
  #links;
  #observer;

  connect() {
    if (this.stickyOffsetValue) {
      this.#connectSectionObserver();
    } else if (window.bootstrap?.ScrollSpy) {
      this.#spy = new window.bootstrap.ScrollSpy(document.body, {
        target: this.element,
        smoothScroll: true,
      });
    }
  }

  disconnect() {
    this.#spy?.dispose();
    this.#observer?.disconnect();
  }

  #connectSectionObserver() {
    this.#links = new Map();
    const sections = [];

    this.element.querySelectorAll('a[href^="#"]').forEach((link) => {
      const id = link.getAttribute('href').slice(1);
      const section = document.getElementById(id);
      if (!section) return;
      this.#links.set(id, link);
      sections.push(section);
    });

    // A band ~40% down the viewport, below the floating bar; the section crossing it is the one being read.
    this.#observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.#activate(entry.target.id);
        });
      },
      { rootMargin: '-40% 0px -60% 0px', threshold: 0 },
    );

    sections.forEach((section) => this.#observer.observe(section));
  }

  #activate(id) {
    this.#links.forEach((link, key) => link.classList.toggle('active', key === id));
  }
}
